export const APP_HREF = 'https://app.pretto.fr/'

export const DESCRIPTION = (
  <p>
    Pour obtenir des résultats plus précis, réalisez gratuitement une <strong>simulation personnalisée</strong> de votre
    projet immobilier.
  </p>
)
